import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import getBaseUrl from '../getBaseUrl';
import { BASE_URL, getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();
export const getUserSessions = createAsyncThunk(
  "userSessions/getUserSessions",
  async (mail, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState();
      // console.log('state', state.snackbar.no_of_days)
      const response = await axios.get(
        `${baseUrl}/sessions?offset=${mail.minRows}&limit=${mail.maxRows}`,
        {
          headers: {
            "Content-Type": "application/json",
            "use-case": "src",
            ...getAuthApiHeaders({
              includeUserEmail: false,
              includeIncomingEmail: true,
            }),
            client: mail.client ? mail.client : "UT",
          },
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Failed to load!", severity: "error" }));
      return rejectWithValue(
        getApiErrorMessage(error, "Failed to load sessions"),
      );
    }
  },
);

const userSessionsSlice = createSlice({
  name: "user-sessions",
  initialState: {
    isLoading: false,
    userSessions: [],
    isError: false,
    error: null,
    success: false,
    duplicate: false,
  },
  reducers: {
    duplicatesRemoval: (state, action) => {
      state.duplicate = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserSessions.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
      state.error = null;
    });
    builder.addCase(getUserSessions.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.error = null;
      // Keep this an array whatever the response shape is: consumers spread it.
      state.userSessions = Array.isArray(action.payload?.sessions)
        ? action.payload.sessions
        : [];
      state.success = true;
    });
    builder.addCase(getUserSessions.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload || action.error?.message || "Failed to load sessions";
      state.success = false;
    });
  },
});
export const { duplicatesRemoval } = userSessionsSlice.actions;
export default userSessionsSlice.reducer;
